type Operator = {
  [key: string]: string | string[] | number;
};

interface QueryBuilderArguments {
  operator?: string;
  field?: string;
  value?: string | string[] | number;
  order?: Order;
}

export type Order = 'ASC' | 'DESC';

interface QueryParams {
  param?: { [key: string]: string };
  where?: { [key: string]: Operator };
  order?: { [key: string]: Order };
  include?: string[];
  limit?: number;
  offset?: number;
}
export class QueryBuilder {
  private query: QueryParams;

  constructor() {
    this.query = {};
  }

  setQueryParam({ field, value }: QueryBuilderArguments) {
    if (!this.query.param) {
      this.query.param = {};
    }
    if (typeof value === 'string' && value && field) {
      this.query.param[field] = value;
    }

    return this;
  }

  setQueryWhere({ field, value, operator }: QueryBuilderArguments) {
    if (!this.query.where) {
      this.query.where = {};
    }
    if (typeof value !== 'number' && value && operator && field) {
      this.query.where[field] = { [operator]: value };
    }
    return this;
  }

  setQueryOrder({ field, order }: QueryBuilderArguments) {
    if (!this.query.order) {
      this.query.order = {};
    }
    if (order && field) {
      this.query.order[field] = order;
    }
    return this;
  }
  setQueryInclude({ field }: QueryBuilderArguments) {
    if (!this.query.include) {
      this.query.include = [];
    }
    if (field && !this.query.include.includes(field.toString())) {
      this.query.include = [...this.query.include, field.toString()];
    }
    return this;
  }
  setQueryLimit({ value }: QueryBuilderArguments) {
    if (!this.query.limit || typeof value === 'string') {
      this.query.limit = 0;
    }
    if (typeof value === 'number') {
      this.query.limit = value;
    }
    return this;
  }
  setQueryOffset({ value }: QueryBuilderArguments) {
    if (!this.query.offset || typeof value === 'string') {
      this.query.offset = 0;
    }
    if (typeof value === 'number') {
      this.query.offset = value;
    }
    return this;
  }

  build() {
    const queryParams = [];

    if (this.query.param && Object.keys(this.query.param).length > 0) {
      const entries = Object.entries(this.query.param);
      entries.map(entry => {
        const [key, val] = entry;
        queryParams.push(`${key}=${val}`);
      });
    }
    if (this.query.where && Object.keys(this.query.where).length > 0) {
      queryParams.push(`where=${JSON.stringify(this.query.where)}`);
    }
    if (this.query.order && Object.keys(this.query.order).length > 0) {
      queryParams.push(`order=${JSON.stringify([...Object.entries(this.query.order)])}`);
    }
    if (this.query.include) {
      queryParams.push(`include=${JSON.stringify(this.query.include)}`);
    }
    if (this.query.limit) {
      queryParams.push(`limit=${this.query.limit}`);
    }

    if (this.query.offset) {
      queryParams.push(`offset=${this.query.offset}`);
    }
    return `${queryParams.join('&')}`;
  }
}
